import styled, { css } from 'styled-components';

export const QuickStartSection = styled.section<{ $topMargin?: boolean }>`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: clamp(400px, 53.61vw, 700px);
  max-height: 700px;
  padding: 170px 0;

  ${({ $topMargin }) =>
    $topMargin &&
    css`
      margin-top: 70px;
    `}

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    background: ${({ theme }) => theme.palette.primary.background};
    padding: 0;
    height: clamp(550px, 60vw, 600px);
    max-height: 600px;

    &::after {
      background: transparent;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0;
    height: clamp(550px, 74vw, 550px);
    max-height: 550px;
  }
`;

export const VideoBackground = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
`;

export const VideoIframe = styled.iframe`
  position: absolute;
  top: 50%;
  left: 50%;
  border: 0;
  width: 100%;
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  transform: translate(-50%, -50%);
  background: transparent;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: max(100%, 205.71vh);
    height: max(100%, 48.61vw);
  }

  // @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
  //   width: 100%;
  //   height: 100%;
  //   min-width: 100%;
  //   min-height: 100%;
  // }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
    min-width: 100%;
    max-width: calc(68.1818vh);
    height: calc(146.667vw);
    min-height: 100%;
    transform: translate(-50%, -50%);
  }

  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`;

export const VideoPoster = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
`;

export const QuickStartContainer = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1280px;
  margin: 0 auto;
  gap: 60px;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 0 40px 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 50%;
    margin: 0;
    padding-top: 100px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 15px;
    flex-direction: column;
    padding: 0 20px;
    gap: 30px;
    max-width: 100%;
    height: 100%;
    margin: 0 auto;
  }
`;

export const QuickStartContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
    text-align: left;
    margin-top: 50px;
    margin-bottom: 50px;
  }
`;

export const QuickStartTitle = styled.h1`
  font-size: 52px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${({ theme }) => theme.palette.primary.labels};
  margin: 0;
  max-width: 572px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 32px;
  }
`;

export const QuickStartDescription = styled.p`
  font-size: 18px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.primary.labels};
  margin-top: 60px;
  max-width: 500px;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    font-size: 15px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 30px;
    max-width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-top: auto;
    max-width: 100%;
  }
`;

export const QuickStartButtons = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
    max-width: 500px;
    flex-direction: row;
    justify-content: center;
    gap: 15px;
    margin-top: 25px;
  }
`;

export const QuickStartButtonPrimary = styled.button`
  padding: 15px 23px;
  border-radius: 14px;
  background: ${({ theme }) => theme.palette.brand.main};
  color: ${({ theme }) => theme.palette.system.white};
  font-size: 16px;
  font-weight: 400;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s;
  width: 190px;

  &:hover {
    background-color: ${({ theme }) => theme.palette.brand.mainOnHover};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex: 1;
    background: ${({ theme }) => theme.palette.brand.main};
    padding: 15px 0;
  }
`;

export const QuickStartButtonSecondary = styled.button`
  padding: 15px 23px;
  border-radius: 14px;
  background: #fef7f4;
  color: ${({ theme }) => theme.palette.brand.main};
  font-size: 16px;
  font-weight: 400;
  border: 1px solid transparent;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s, color 0.2s;
  width: 190px;

  &:hover {
    background-color: #ffefe9;
    color: ${({ theme }) => theme.palette.brand.main};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex: 1;
    padding: 15px 0;
  }
`;
